import { useParams } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import navConfig from './interface/navConfig.json';
import ProfileNav from './interface/ProfileNav.jsx';
import Post_content from '../community/content/Blog_posts.jsx';

// Tìm route trong cấp items và children
function findRouteBySlug(slug_2, items) {
  for (const item of items) {
    if (item.slug_2 === slug_2) {
      return item;
    }
    if (item.children) {
      const child = item.children.find(c => c.slug_2 === slug_2);
      if (child) {
        return child;
      }
    }
  }
  return null;
}

// component Home nhận vào category (từ route props) và lấy slug_2 từ useParams
function Home({ category }) {
  const { slug_2 } = useParams();

  // Tìm cấu hình category
  const categoryConfig = navConfig.find(cat => cat.category === category);
  if (!categoryConfig) {
    return <div>Không tìm thấy danh mục: {category}</div>;
  }

  // Lấy danh sách items trong danh mục
  const items = categoryConfig.items;

  // Tìm route tương ứng theo slug_2
  let currentRoute = findRouteBySlug(slug_2, items);
  if (!currentRoute) {
    return <div>Không tìm thấy trang: {slug_2}</div>;
  }

  // Nếu là mục cha (không có componentPath nhưng có children), chuyển sang child đầu tiên
  if (!currentRoute.componentPath && currentRoute.children && currentRoute.children.length > 0) {
    currentRoute = currentRoute.children[0];
  }
  // Lazy-load component nếu có componentPath
  const ComponentToRender = currentRoute.componentPath
  ? lazy(() => import(`${currentRoute.componentPath}`))
  : null;
console.log(ComponentToRender);

  return (
    <>
      <div className="text-center mt-2">
        <div className="inline-block border-gray-200 text-center font-medium text-gray-500 bg-slate-100 py-1 px-2 rounded-xl">
          <ProfileNav category={category} />
        </div>
      </div>

      {slug_2 === 'tricks' ? (
        <div className="mt-1 mb-3">
          <Post_content mode={'telegram'} show_adsense="YES" channel="freefltiktok" id_post="69" />
        </div>
      ) : ComponentToRender ? (
        <Suspense fallback={<div>Loading...</div>}>
          <ComponentToRender />
        </Suspense>
      ) : (
        <div>Không có component để hiển thị</div>
      )}
    </>
  );
}

export default Home;
